import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';
import { Range } from 'types';

type ShareRangeRowProps = {
  index: number;
  sharesRanges: Range[];
};

const ShareRangeRow: FC<ShareRangeRowProps> = ({
  index,
  sharesRanges,
}: ShareRangeRowProps) => {
  const { t } = useTranslate();

  return (
    <div className="form-control-wrap pb-1">
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id={`share-from-${index}`}>
            {t('OfTheNo')}
          </span>
        </div>
        <NumberFormat
          id={`share-from-${index}`}
          className="form-control form-control-outlined"
          value={sharesRanges?.[index]?.from}
          readOnly
          disabled
          thousandSeparator={numberFormat.thousandSeparator}
          decimalSeparator={numberFormat.decimalSeparator}
        />

        <div className="input-group-prepend">
          <span className="input-group-text" id={`share-to-${index}`}>
            {t('ToTheNo')}
          </span>
        </div>
        <NumberFormat
          id={`share-to-${index}`}
          className="form-control form-control-outlined"
          value={sharesRanges?.[index]?.to}
          readOnly
          disabled
          thousandSeparator={numberFormat.thousandSeparator}
          decimalSeparator={numberFormat.decimalSeparator}
        />
      </div>
    </div>
  );
};

export default ShareRangeRow;
